import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { componentInvariants } from 'bloko/common/helpers/customPropTypes';

import 'bloko/blocks/gap/gap.less';

export default function Gap({
    children,
    top,
    right,
    left,
    bottom,
    mTop,
    mRight,
    mLeft,
    mBottom,
    sTop,
    sRight,
    sBottom,
    sLeft,
    xsTop,
    xsRight,
    xsLeft,
    xsBottom,
    lTop,
    lRight,
    lBottom,
    lLeft,
    Element,
    ...gapProps
}) {
    return (
        <Element
            className={classnames('bloko-gap', {
                'bloko-gap_top': top,
                'bloko-gap_right': right,
                'bloko-gap_left': left,
                'bloko-gap_bottom': bottom,

                'bloko-gap_s-top': sTop,
                'bloko-gap_s-right': sRight,
                'bloko-gap_s-left': sLeft,
                'bloko-gap_s-bottom': sBottom,

                'bloko-gap_m-top': mTop,
                'bloko-gap_m-right': mRight,
                'bloko-gap_m-left': mLeft,
                'bloko-gap_m-bottom': mBottom,

                'bloko-gap_xs-top': xsTop,
                'bloko-gap_xs-right': xsRight,
                'bloko-gap_xs-left': xsLeft,
                'bloko-gap_xs-bottom': xsBottom,

                'bloko-gap_l-top': lTop,
                'bloko-gap_l-right': lRight,
                'bloko-gap_l-left': lLeft,
                'bloko-gap_l-bottom': lBottom,
            })}
            {...gapProps}
        >
            {children}
        </Element>
    );
}

Gap.propTypes = {
    /** Содержимое внутри отступа */
    children: PropTypes.node,
    /** Добавить отступ сверху */
    top: PropTypes.bool,
    /** Добавить отступ справа */
    right: PropTypes.bool,
    /** Добавить отступ слева */
    left: PropTypes.bool,
    /** Добавить отступ снизу */
    bottom: PropTypes.bool,
    /** Добавить отступ сверху для m размера */
    mTop: PropTypes.bool,
    /** Добавить отступ справа для m размера */
    mRight: PropTypes.bool,
    /** Добавить отступ слева для m размера */
    mLeft: PropTypes.bool,
    /** Добавить отступ снизу для m размера */
    mBottom: PropTypes.bool,
    /** Добавить отступ сверху для s размера */
    sTop: PropTypes.bool,
    /** Добавить отступ справа для s размера */
    sRight: PropTypes.bool,
    /** Добавить отступ снизу для s размера */
    sBottom: PropTypes.bool,
    /** Добавить отступ слева для s размера */
    sLeft: PropTypes.bool,
    /** Добавить отступ сверху для xs размера */
    xsTop: PropTypes.bool,
    /** Добавить отступ справа для xs размера */
    xsRight: PropTypes.bool,
    /** Добавить отступ слева для xs размера */
    xsLeft: PropTypes.bool,
    /** Добавить отступ снизу для xs размера */
    xsBottom: PropTypes.bool,
    /** Добавить отступ сверху для l размера */
    lTop: PropTypes.bool,
    /** Добавить отступ справа для l размера */
    lRight: PropTypes.bool,
    /** Добавить отступ снизу для l размера */
    lBottom: PropTypes.bool,
    /** Добавить отступ слева для l размера */
    lLeft: PropTypes.bool,
    /** Кастомный компонент функция или 'span', 'div' */
    Element: componentInvariants(['span', 'div']),
};

Gap.defaultProps = {
    Element: 'div',
};
